var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"judging-shortcut",attrs:{"href":_vm.route(_vm.url)}},[_c('div',{staticClass:"icon"},[_c('icon',{attrs:{"name":"add"}})],1),_vm._v(" "),_c('div',{staticClass:"action"},[_vm._v(_vm._s(_vm.action))])])}
var staticRenderFns = []

export { render, staticRenderFns }